import { lazy } from "react";

/**
 * React.lazy with a .preload() method. Once preload() has resolved, the
 * lazy factory returns a synchronously-resolving thenable, so React renders
 * the component on the first pass without suspending. This keeps
 * ReactDOM.hydrate from replacing react-snap pre-rendered HTML with the
 * Suspense fallback while the chunk is still loading.
 */
export function lazyWithPreload(factory) {
  const state = { module: null, promise: null };

  // Memoized so concurrent preload()/render calls share one load; the
  // memoized promise is cleared on failure so a later call can retry.
  const load = () => {
    if (!state.promise) {
      state.promise = factory().then(
        (module) => {
          state.module = module;
          return module;
        },
        (error) => {
          state.promise = null;
          throw error;
        },
      );
    }
    return state.promise;
  };

  const Component = lazy(() =>
    state.module ? { then: (resolve) => resolve(state.module) } : load(),
  );
  Component.preload = load;

  return Component;
}
